import styled from "styled-components";
import { transparentize } from "polished";

export const StyledSize = styled.div`
    height: calc(100% - 100px);
`;

export const Score = styled.div`
    display: inline-block;
    position: absolute;
    transform-origin: top left;
    box-sizing: border-box;
    box-shadow: 0 0 0 4px ${p => p.theme.c.boost};
    cursor: pointer;
    background-color: ${p => transparentize(1 - 0.4, p.theme.c.active)};

    img {
        pointer-events: none;
        user-select: none;
        mix-blend-mode: multiply;
        display: block;
    }
`;

export const ScaleBar = styled.div`
    position: absolute;
    bottom: 4px;
    text-align: center;
    width: calc(100%);
`;

export const ScaleBarContainer = styled.div`
    display: inline-block;
    position: relative;
`;